import styled from "styled-components";
import Icon from "../../../../components/Icon/Icon";

interface DropZoneProps {
  $isDragging: boolean;
}

// The shared Modal sizes itself to its content plus its own 20px side
// margins, so this min-width is what sets the popup width:
// 326 + 48 (modal body padding) + 40 = 414px.
export const DropZone = styled.div<DropZoneProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 326px;
  padding: 40px 20px;
  text-align: center;
  border: 1px dashed
    ${({ theme, $isDragging }) =>
      $isDragging ? theme.primary : theme.formBorder};
  border-radius: 7px;
  background-color: ${({ theme, $isDragging }) =>
    $isDragging ? theme.primary10 : theme.dropdownBg};
  transition:
    border-color 0.15s,
    background-color 0.15s;

  ${({ theme }) => theme.xs`
    min-width: 0;
  `}
`;

export const DropZoneIcon = styled(Icon)`
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => theme.primary};
`;

export const DropZoneText = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${({ theme }) => theme.textMain};
`;

export const DropZoneHint = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
`;
